import { createContext, FC, PropsWithChildren, useContext } from 'react'

interface SidebarMenuItemType {
  closeHover: () => void
}

export const SidebarMenuItemContext = createContext<SidebarMenuItemType | null>(null)

const SidebarMenuItemProvider: FC<PropsWithChildren<SidebarMenuItemType>> = ({
  closeHover,
  children,
}) => {
  return (
    <SidebarMenuItemContext.Provider value={{ closeHover }}>
      {children}
    </SidebarMenuItemContext.Provider>
  )
}

export default SidebarMenuItemProvider

export const useSidebarMenuItemContext = () => {
  const context = useContext(SidebarMenuItemContext)
  if (!context) {
    throw new Error('useSidebarMenuItem must be used within a SidebarMenuItemProvider')
  }
  return context
}
